export default __webpack_public_path__ + "static/4-11cca8953836807fb096e41d923c1753.jpeg";